import React from "react";
import { useSelector } from "react-redux";
import AreaChart from "../../../../components/areaChart/areaChart";

const YearOverYear = () => {
  const profilesYearOverYearComparison = useSelector(
    (state) => state.leadsAdded.profilesYearOverYearComparison
  );
  return <AreaChart chartData={profilesYearOverYearComparison} width={1350} hideCurrency />;
};

export default YearOverYear;
